export const BOROS = [
  { code: 1, name: "Manhattan" },
  { code: 2, name: "Bronx" },
  { code: 3, name: "Brooklyn" },
  { code: 4, name: "Queens" },
  { code: 5, name: "Staten Island" },
];

export function boroNameByCode(boroCode: number | string) {
  const boroCodeInt = parseInt(boroCode.toString());
  return BOROS.find((boro) => boro.code === boroCodeInt)?.name || "unknown";
}
